import React from "react";

const context = React.createContext({
  services: [
    {
      img: "",
      title: "first",
      description: "about first ",
    },
    {
      img: "",
      title: "second",
      description: "about second ",
    },
  ],
  projects: [
    {
      title: "crud",
    },
  ],
});

export const ContextProvider = (props) => {
  return (
    <context.Provider value={{ data: context._currentValue }}>
      {props.children}
    </context.Provider>
  );
};

export default context;
